//
// ModuleData
//
// A plain ModuleData object to hold properties

import { action, makeObservable, observable } from 'mobx'

import { removeListValue } from '../../utils/list'
import { updateInstanceWithData } from './utils'

export class ModuleData {
    name = ''
    version = ''
    keys = new Map()
    actions = new Map()
    logs = []

    constructor(moduledata, rootstore) {
        makeObservable(this, {
            name: observable,
            version: observable,
            keys: observable,
            actions: observable,
            logs: observable,
            unregisterModule: action.bound,
        })

        this._rootstore = rootstore
        this.update(moduledata)
    }

    update = moduledata => {
        updateInstanceWithData(this, moduledata, [
            'name',
            'version',
            'keys',
            'actions',
            'logs',
        ])
    }

    unpublishAction = action_name => {
        return this._rootstore
            ._fetch('/modules/actions/unpublish', {
                module: this.name,
                action: action_name,
            })
            .catch(error => {
                // in use - report to user?
            })
    }

    unregisterModule = () => {
        return this._rootstore
            ._fetch('/modules/unregister', { module: this.name })
            .then(result => {
                this._rootstore.data.modules.delete(this.name)
                this._rootstore.data.module_names.replace(
                    removeListValue(this._rootstore.data.module_names, this.name)
                )
                return result
            })
            .catch(error => {
                // in use - report to user?
            })
    }
}
